import React from 'react';
import SectionHeader from './ui/SectionHeader';
import useRevealOnScroll from '../hooks/useRevealOnScroll';

const amenities = [
  { title: 'Microwave' },
  { title: 'Mini fridge' },
  { title: 'Television & cable' },
  { title: 'Free Wi-Fi' },
  { title: 'Coffee kettle' },
  { title: 'Free parking for boats, trucks, and RVs (1 spot per room)' }
];

const CheckIcon = () => (
  <svg className="h-5 w-5 text-brand-accent" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
    <path
      fillRule="evenodd"
      d="M16.704 5.29a1 1 0 010 1.42l-7.21 7.21a1 1 0 01-1.42 0l-3.21-3.21a1 1 0 011.42-1.42l2.5 2.5 6.5-6.5a1 1 0 011.42 0z"
      clipRule="evenodd"
    />
  </svg>
);

const AmenitiesSection = () => {
  const { ref, isVisible } = useRevealOnScroll();

  return (
    <section id="amenities" className="section-shell pt-0">
      <div ref={ref} className={`card-surface p-8 md:p-12 ${isVisible ? 'reveal-visible' : ''} reveal`}>
        <SectionHeader
          eyebrow="Included Essentials"
          title="Thoughtful amenities in every stay"
          subtitle="Each room includes practical features that make short and extended stays easier."
        />

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {amenities.map((amenity) => (
            <div key={amenity.title} className="flex items-start gap-3 rounded-xl border border-brand-border bg-[#fbf7ef] p-4">
              <CheckIcon />
              <p className="text-sm font-medium text-brand-primary">{amenity.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AmenitiesSection;
